export default "__VITE_ASSET__3a4ce35f__"